import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import Notify from '@/components/Notification';
import { fundraisingService } from '../../services/fundraisingService';

export const useResetFundraising = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const response = await fundraisingService.resetFundraising();
      const { status, data } = response;

      if (status === 200) {
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.fundraising.status] }),
          queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.fundraising.status_by_id] }),
        ]);
        Notify.success({ text: 'Fundraising reset successfully' });
        return data;
      }
    },
  });
};
